const YA_COUNTER_KEY_RE = /^yaCounter(\d+)$/
const YA_COUNTER_INIT_RE = /ym\((\d+)\s*,\s*['"]init['"]/

let cachedCounterId

/**
 * Resolve Yandex.Metrika counter id from the page (yaCounter* global or script tag).
 * @returns {number | null}
 */
export const getYandexMetrikaCounterId = () => {
  if (cachedCounterId !== undefined) {
    return cachedCounterId
  }

  if (typeof window === 'undefined') {
    return null
  }

  const yaCounterKey = Object.keys(window).find((key) => YA_COUNTER_KEY_RE.test(key))
  if (yaCounterKey) {
    cachedCounterId = Number(yaCounterKey.slice('yaCounter'.length))
    return cachedCounterId
  }

  const metrikaScript = document.getElementById('metrika-counter')
  const counterFromAttr = metrikaScript?.dataset?.counterId
  if (counterFromAttr) {
    cachedCounterId = Number(counterFromAttr)
    return cachedCounterId
  }

  const initMatch = metrikaScript?.textContent?.match(YA_COUNTER_INIT_RE)
  if (initMatch) {
    cachedCounterId = Number(initMatch[1])
    return cachedCounterId
  }

  cachedCounterId = null
  return cachedCounterId
}

export const getYandexMetrikaCounter = () => {
  const counterId = getYandexMetrikaCounterId()
  if (!counterId) return null

  return window[`yaCounter${counterId}`] || null
}

/**
 * Send reachGoal to Yandex.Metrika via yaCounter and ym API.
 * @param {string} goal
 * @param {object} [params]
 */
export const reachYandexGoal = (goal, params) => {
  const counter = getYandexMetrikaCounter()
  const counterId = getYandexMetrikaCounterId()

  if (counter) {
    counter.reachGoal(goal, params)
  }

  if (counterId && typeof window?.ym === 'function') {
    window.ym(counterId, 'reachGoal', goal, params)
  }
}
